// Form draft handling for data-entry pages kept alive by the taskbar.
// Spec: docs/specs/2026-10-07-bo-form-draft-clear-design.md §3 (F1).
//
// A page using this mixin must define `resetForm()` that puts every field
// back to its initial state (data(), file inputs, child components,
// validation observer). The mixin adds:
//   clearForm()      – asks first (swal), then resetForm(), then a short toast
//   afterSaveReset() – resetForm() with no question; call it right after a
//                      successful save and BEFORE any $router.push away, so
//                      the cached tab is empty the next time it is opened.
// Keeping the draft while the user has not saved is the keep-alive default
// (F4): nothing here persists to storage.
import swal from "sweetalert2";

export default {
	methods: {
		formDraftAssertReset() {
			if (typeof this.resetForm !== "function") {
				throw new Error("formDraft mixin: the page must define resetForm()");
			}
		},
		clearForm() {
			this.formDraftAssertReset();
			return swal
				.fire({
					title: this.$t("form_draft.clear_confirm_title"),
					text: this.$t("form_draft.clear_confirm_text"),
					icon: "warning",
					showCancelButton: true,
					reverseButtons: true,
					confirmButtonText: this.$t("form_draft.clear"),
					cancelButtonText: this.$t("cancel"),
					confirmButtonClass: "btn btn-danger btn-fill",
					cancelButtonClass: "btn btn-secondary btn-fill",
					buttonsStyling: false
				})
				.then(result => {
					if (!result || !result.value) return false;
					this.resetForm();
					swal.fire({
						title: this.$t("form_draft.cleared"),
						icon: "success",
						timer: 1200,
						showConfirmButton: false
					});
					return true;
				});
		},
		afterSaveReset() {
			this.formDraftAssertReset();
			this.resetForm();
		}
	}
};
